import React from "react";
import './LeftRightBtn.css'

function LeftRightBtn() {

    const handleCallClick = () => {
        window.location.href = process.env.REACT_APP_CALL_ME;
    };
    const handleWhatsAppClick = () => {
        window.location.href = process.env.REACT_APP_WHATSAPP_ME;
    };

    return (
        <>
            <div className="top-btn-left" >
                <i className="fa-brands fa-whatsapp" onClick={handleWhatsAppClick}></i>
            </div>
            <div className="top-btn-right" >
                <i className="fa-sharp fa-solid fa-phone-volume" onClick={handleCallClick}></i>
            </div>
        </>
    )
}

export default LeftRightBtn;